/*
 *  ~~~~~ Copyright by inndevs GmbH / DDC Engineering GmbH ~~~~~
 *
 *               Your favorite programmers ;-)
 *
 * E-Mail:   hannes@inndevs.com
 *           dominic@ddc-engineering.at
 * Web:      https://inndevs.com
 *           https://ddc-engineering.at
 * Date:     2021-05-16
 *
 *   ________________________________________
 * [[ MESS WITH THE BEST - DiE LIKE THE REST ]]
 *   ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
 */


import {Fragment, useEffect, useMemo, useState} from "react"
import Bus from "./js/Bus";
import {Login} from "./component/layout/Login";
import {KeyDirect} from "./component/layout/KeyDirect";
import {Route, Switch} from "react-router";
import {Payment} from "./component/layout/Payment";
import {Impressum} from "./view/home/Impressum";
import {Layout} from "./component/layout/Layout";
import {QrOrder} from "./controller/QrOrder";
import {AGB} from "./view/home/AGB";
import {Datenschutz} from "./view/home/Datenschutz";
import {Widerrufsrecht} from "./view/home/Widerrufsrecht";
import {useHistory} from "react-router-dom";
import {get, post} from "./js/api";
import {UpdateGuestRequest} from "./view/guestRequest/UpdateGuestRequest";
import {UpdatePublicOrder} from "./view/publicOrder/UpdatePublicOrder";
import {GuestRequestV2} from "./view/guestRequest/GuestRequestV2";
import {GuestRequestPriceList} from "./view/guestRequest/GuestRequestPriceList";
import {fetchAuthSession} from "aws-amplify/auth";
import {registerErrorSender} from "./js/errorhandling";

export const isRequestDomain = (config) => window.location.host.indexOf(config.default['requestRedirect']) > -1;

function App() {

    const sprueche = useMemo(() =>
        ["Der Schlüssel zum Glück? Geduld. Und vielleicht ein guter Schlüsseldienst.",
        "Der Schlüssel zum Glück liegt manchmal einfach im richtigen Moment - oder im richtigen Schloss.",
        "Wenn sich gerade keine Tür öffnet: Einfach kurz warten, wir arbeiten daran.",
        "Manchmal klemmt nicht das Schloss, sondern nur kurz die Technik.",
        "Der Schlüssel zum Glück? Geduld - wir sind gleich wieder da."], [])

    const [isLoggedIn, setLoggedIn] = useState(null);
    const [showMaintenance, setShowMaintenance] = useState(null);
    const [configLoaded, setConfigLoaded] = useState(false);
    const [currentVersion, setCurrentVersion] = useState();
    const history = useHistory();

    const handleStateUpdate = (state) => {
        switch (state) {
            case "signedIn":
                setLoggedIn(true);
                break;
            default:
                setLoggedIn(false);
        }
    };

    useEffect(() => {
        //make dark theme standard
        document.querySelector(":root").classList.add("dark-theme");

        registerErrorSender((error) => {
            post('/logs/logerror', error).then(() => {
                console.log("Successfully logged error");
            });
        });

        Bus.removeAllListeners("loginstate");
        Bus.addListener("loginstate", handleStateUpdate);

        loadVersion();

        loadConfiguration().then(config => {
            setConfigLoaded(true);

            get("/public/app-state", false).then(e => setShowMaintenance(e.maintenance)).catch(e => {
                setShowMaintenance(true);
                throw e;
            })

            // redirect upload. domain to guest-request
            if(isRequestDomain(config) && window.location.pathname == "/"){
                history.push("/guest-request");
            }
        });

        fetchAuthSession({ forceRefresh: true }).then((session) => {
            setLoggedIn(!!session.tokens?.idToken)
        }).catch(() => setLoggedIn(false));
    }, []);

    useEffect(() => {
        //every hour check for a new version (long open tab, I don't want to go chasing bugs)
        const interval = setInterval(loadVersion, 60*60*1000);

        return () => clearInterval(interval)
    }, [currentVersion]);

    const loadVersion = () => {
        fetch("/version.json").then((res) => {
            if (!res.ok) {
                throw new Error
                (`HTTP error! Status: ${res.status}`);
            }
            return res.json();
        }).then(res => {
                if(currentVersion && currentVersion != res.version){
                    if(window.confirm("Neue Version verfügbar, bitte laden Sie die Seite neu. Drücken Sie dafür auf OK.")) {
                        window.location.reload();
                    }else{
                        return;
                    }
                }
                setCurrentVersion(res.version);
        }).catch((error) =>
                console.error("Unable to fetch data:", error));
    }

    return (
        <Fragment>
            {configLoaded && <Switch>
                <Route exact path="/payments/:paymentId/:done?">
                    <Payment />
                </Route>
                <Route path="/impressum">
                    <Layout>
                        <Impressum/>
                    </Layout>
                </Route>
                <Route path="/agb">
                    <Layout>
                        <AGB/>
                    </Layout>
                </Route>
                <Route path="/datenschutz">
                    <Layout>
                        <Datenschutz/>
                    </Layout>
                </Route>
                <Route path="/widerrufsrecht">
                    <Layout>
                        <Widerrufsrecht/>
                    </Layout>
                </Route>
                <Route exact path="/guest-request">
                    <GuestRequestV2></GuestRequestV2>
                </Route>
                <Route exact path="/price-list">
                    <GuestRequestPriceList></GuestRequestPriceList>
                </Route>
                <Route exact path="/guest-request/:token">
                    <UpdateGuestRequest/>
                </Route>
                <Route exact path="/public-order/:token">
                    <UpdatePublicOrder/>
                </Route>
                <Route path="/qr/:qr">
                    <QrOrder/>
                </Route>
                <Route path="*">
                    {showMaintenance === false && <>
                        {isLoggedIn === false && <Login handleStateUpdate={handleStateUpdate}/>}
                        {isLoggedIn === true && <KeyDirect/>}
                    </>}
                    {showMaintenance === true && <Layout>
                        <div>
                            <h1>Wartungsarbeiten</h1>
                            <p>Wir sind gerade dabei Keydirect noch besser zu machen, bitte kommen Sie später wieder.</p>

                            <h3>{sprueche[Math.floor(Math.random() * sprueche.length)]}</h3>
                        </div>
                    </Layout>}
                </Route>
            </Switch>}
        </Fragment>
    );

}

//TODO: move and cache?
export const loadConfiguration = ()=>{
    return import('./config/'+process.env.REACT_APP_CONFIG+".js");
}

export default App;
